<div class="flex justify-content-center noshowSpinner">
  <div><p-progressSpinner ariaLabel="loading" /></div>
</div>
<div class="flex justify-content-center noshowText">
  <span>Connecting to your social media account...</span>
</div>
